import { Component, OnInit } from '@angular/core';
import { AuthorisedSideNavService } from '../../../layout/authorised/services/authorised-side-nav.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
loggeduser: any;
  constructor(public sideNavService: AuthorisedSideNavService) { }

  ngOnInit(): void {
   if(this.isLoggedIn())
   {
  this.loggeduser=JSON.parse(localStorage.getItem('seocurrentUser'));
  console.log(this.loggeduser.First);
  }
 
  }
  isLoggedIn() {
    if (localStorage.getItem('seocurrentUser')) {
      return true;
    }
    return false;
  }


}
